const auxColor = new THREE.Color();

/**
 * Listen to stage-events to change curve color.
 */
AFRAME.registerComponent('supercurve-color', {
  init: function () {
    const el = this.el;

    el.sceneEl.addEventListener('curveevenstageeventcolor', evt => {
      if (!evt.detail || evt.detail === 'off') {
        this.setColor('color1', 'primary');
        return;
      }
      this.setColor('color1', evt.detail);
    });

    el.sceneEl.addEventListener('curveoddstageeventcolor', evt => {
      if (!evt.detail || evt.detail === 'off') {
        this.setColor('color2', 'secondary');
        return;
      }
      this.setColor('color2', evt.detail);
    });
  },

  setColor: function (uniform, colorId) {
    const colorVec = this.el.components.material.material.uniforms[uniform].value;
    const color = this.el.sceneEl.systems.materials.scheme[colorId];
    auxColor.set(color);
    colorVec.x = auxColor.r;
    colorVec.y = auxColor.g;
    colorVec.z = auxColor.b;
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['supercurve-color',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
